import React from 'react';
import styled from 'styled-components';
import { HeaderTitle } from '../../../utils/budget-tool-specific';
import AssistantData from './assistant-data';

const Assistant = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Assistant
            </HeaderTitle>
            <AssistantData />
        </PageContainer>
    )
}

export default Assistant;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;